const mix = (from, to, progress) => -progress * from + progress * to + from;

export { mix };
